import { Button } from '@seen/ui'
import { IconAlertCircle, IconHome, IconRefresh } from '@tabler/icons-react'
import type { JSX } from 'react'
import { useLocation } from 'react-router'
import { Card } from '#src/components/core/Card.tsx'
import { useDidChange } from '#src/hooks/useDidChange.ts'

export function ErrorFallback({
  error,
  resetError,
}: {
  error: unknown
  resetError: () => void
}): JSX.Element {
  const location = useLocation()
  const url = `${location.pathname}${location.search}${location.hash}`
  const urlChanged = useDidChange(url)
  if (urlChanged) {
    resetError()
  }
  // Output to the console so that console integrations can capture and report to respective systems
  console.error(error)

  return (
    <div className="flex h-full w-full items-center justify-center">
      <Card className="flex h-40 w-2/3 flex-col items-center justify-center">
        <h2 className="flex items-center gap-2 text-lg font-semibold">
          <IconAlertCircle className="size-6" /> Something went wrong
        </h2>
        <p className="text-sm text-muted-foreground">
          The tech team has been alerted and is investigating.
        </p>
        <div className="mt-4 flex gap-3">
          <Button variant="outline" onClick={() => window.location.reload()}>
            <IconRefresh className="mr-2 size-4" />
            Try Again
          </Button>
          <Button
            onClick={() => {
              window.location.href = '/'
            }}
          >
            <IconHome className="mr-2 size-4" />
            Go Home
          </Button>
        </div>
      </Card>
    </div>
  )
}
